<ng-container
  class="uni-plural"
>
  <ng-content></ng-content>
  {{ getTranslation(amount) }}
</ng-container>
